export enum ProcessLotsDerivedFrom {
    Search,
    Scan,
}
